import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

class Shop extends Component {
  render() {
    return (
      <div className="App">
        <img className="logo" src={logo} alt="Logo" />
        <br />
        <div>Thailand's Aikido Association Shop...</div>
        <br />

        <div><Link to="/shop-shirts">Shirts</Link></div>
        <div><Link to="/shop-gi">Gi</Link></div>
        <div><Link to="/shop-hakama-belts">Hakama and Belts</Link></div>
        <div><Link to="/shop-accessories">Accessories</Link></div>
        <div><Link to="/shop-weapons">Weapons</Link></div>
        <br />
        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default Shop;
